export default "__VITE_ASSET__tNhyJHrw__"